"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosProductUpdateInputSchema = exports.APosProductCreateInputSchema = exports.APosProductSchema = exports.APosOptionAxisSchema = exports.APosOptionValueSchema = exports.APosLoyaltyConfigSchema = exports.APosAlertConfigSchema = exports.APosProductLabelSchema = exports.APosProductStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosProductStatusSchema = zod_1.z.enum(['active', 'inactive', 'draft', 'archived']);
exports.APosProductLabelSchema = zod_1.z.object({
    type: zod_1.z.enum(['age_restricted', 'new', 'sale', 'custom']),
    text: zod_1.z.string().min(1).max(50),
    color: zod_1.z.string().max(20),
});
// Compliance alert config — product-level default, overridable per variant
exports.APosAlertConfigSchema = zod_1.z.object({
    hasActiveAlert: zod_1.z.boolean().default(false),
    alertType: zod_1.z.string().max(50).optional(),
    alertMessage: zod_1.z.string().max(500).optional(),
});
// Loyalty config — product-level default, overridable per variant or per VariantLocation
exports.APosLoyaltyConfigSchema = zod_1.z.object({
    pointsEarningEnabled: zod_1.z.boolean().default(false),
    pointsPerDollar: zod_1.z.number().nonnegative().optional(),
    redemptionEnabled: zod_1.z.boolean().default(false),
    pointsValue: zod_1.z.number().nonnegative().optional(),
    discountable: zod_1.z.boolean().default(true),
    maxDiscountPercent: zod_1.z.number().min(0).max(100).optional(),
    vipExclusive: zod_1.z.boolean().default(false),
    vipMinTier: zod_1.z.string().max(50).optional(),
    memberPricingEnabled: zod_1.z.boolean().default(false),
    memberDiscountPercent: zod_1.z.number().min(0).max(100).optional(),
});
// Option levels (Clothing: Color / Size; Product with Options: up to 3 named
// levels). Each value is one choice on its level; variants point back at them
// through variant.options.
exports.APosOptionValueSchema = zod_1.z.object({
    value: zod_1.z.string().min(1).max(40).refine(v => !v.includes(' / '), 'Cannot contain " / "'),
    hex: zod_1.z.string().regex(/^#[0-9a-fA-F]{6}$/).optional(),
    images: zod_1.z.array(zod_1.z.string().url()).optional(),
    sortOrder: zod_1.z.number().int().nonnegative(),
});
exports.APosOptionAxisSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(20),
    values: zod_1.z.array(exports.APosOptionValueSchema).max(60),
});
exports.APosProductSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    productId: id_schema_1.EntityIdSchema,
    productTypeId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(200),
    brandId: id_schema_1.EntityIdSchema.optional(),
    description: zod_1.z.string().max(2000).optional(),
    categoryId: id_schema_1.EntityIdSchema.optional(),
    additionalCategoryIds: zod_1.z.array(zod_1.z.string()).optional(),
    tags: zod_1.z.array(zod_1.z.string()).default([]),
    images: zod_1.z.array(zod_1.z.string().url()).default([]),
    labels: zod_1.z.array(exports.APosProductLabelSchema).default([]),
    searchKeywords: zod_1.z.array(zod_1.z.string()).optional(),
    trackInventory: zod_1.z.boolean().default(true),
    status: exports.APosProductStatusSchema.default('draft'),
    statusHistory: zod_1.z.array(zod_1.z.object({
        from: zod_1.z.string(),
        to: zod_1.z.string(),
        changedBy: zod_1.z.string().optional(),
        changedByName: zod_1.z.string().optional(),
        changedAt: zod_1.z.number(),
    })).optional(),
    variantAlias: zod_1.z.string().max(50).optional(),
    optionAxes: zod_1.z.array(exports.APosOptionAxisSchema).max(3).optional(),
    lastPublishedAt: zod_1.z.number().optional(),
    createdBy: zod_1.z.string().optional(),
    createdByName: zod_1.z.string().optional(),
    createdByEmail: zod_1.z.string().optional(),
    lastPublishedBy: zod_1.z.string().optional(),
    lastPublishedByName: zod_1.z.string().optional(),
    lastPublishedByEmail: zod_1.z.string().optional(),
    alertConfig: exports.APosAlertConfigSchema.optional(),
    loyaltyConfig: exports.APosLoyaltyConfigSchema.optional(),
    // AI Inventory Alerts — supplier + replenishment lead time
    defaultSupplierId: zod_1.z.string().optional(),
    leadTimeDays: zod_1.z.number().int().nonnegative().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosProductCreateInputSchema = zod_1.z.object({
    productTypeId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(200),
    brandId: id_schema_1.EntityIdSchema.optional(),
    description: zod_1.z.string().max(2000).optional(),
    categoryId: id_schema_1.EntityIdSchema.optional(),
    additionalCategoryIds: zod_1.z.array(zod_1.z.string()).optional(),
    tags: zod_1.z.array(zod_1.z.string()).optional(),
    images: zod_1.z.array(zod_1.z.string().url()).optional(),
    labels: zod_1.z.array(exports.APosProductLabelSchema).optional(),
    searchKeywords: zod_1.z.array(zod_1.z.string()).optional(),
    trackInventory: zod_1.z.boolean().optional(),
    variantAlias: zod_1.z.string().max(50).optional(),
    optionAxes: zod_1.z.array(exports.APosOptionAxisSchema).max(3).optional(),
    alertConfig: exports.APosAlertConfigSchema.optional(),
    loyaltyConfig: exports.APosLoyaltyConfigSchema.optional(),
});
exports.APosProductUpdateInputSchema = exports.APosProductCreateInputSchema.partial().extend({
    status: exports.APosProductStatusSchema.optional(),
});
//# sourceMappingURL=product.schema.js.map